/** Predefined error messages that will result in special error boundary handling for display to the user. */
export const ErrorMessages = Object.freeze({
    TokenMissing: "Token Missing",
    DestMissing: "Destination Missing",
    UnableToRefresh: "Unable to refresh authentication token.",
});
